import { createContext, useEffect, useState } from "react";
//import { confirm } from "../components/shared/CustomConfirmModel";
import { useLocation } from "react-router-dom";

const GlobalContext = createContext();

export const GlobalContextProvider = ({ children }) => {
  const location = useLocation();
  const [addMasterModel, setAddMasterModel] = useState(false);
  const [isDashboardDrawerOpen, setIsDashboardDrawerOpen] = useState(false);
  const [isMobileWebView, setIsMobileWebView] = useState(false);
  const [tableLoaderShow, setTableLoaderShow] = useState(false);
  const [profileImg, setProfileImg] = useState(
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQIf4R5qPKHPNMyAqV-FjS_OTBB8pfUV29Phg&s"
  );
  const [isUserAuth, setIsUserAuth] = useState(
    localStorage.getItem("isRegisteredUser") === "true" || false
  );

  // const displayModal = async (props) => {
  //   let result = await confirm({ ...props });
  //   return result;
  // };

  // const confirmationModal = async (props) => {
  //   let result = await confirm({ ...props });
  //   return result;
  // };

  useEffect(() => {
    if (location?.pathname) {
      setTableLoaderShow(false);
    }
  }, [location?.pathname]);

  return (
    <GlobalContext.Provider
      value={{
        addMasterModel,
        setAddMasterModel,
 
        isMobileWebView,
        setIsMobileWebView,
     
        isDashboardDrawerOpen,
        setIsDashboardDrawerOpen,
        isUserAuth,
        setIsUserAuth,
        tableLoaderShow,
        setTableLoaderShow,
        setProfileImg,
        profileImg
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
export default GlobalContext;
